function Navbar() {
  return (
    <nav>
      <h1>Perfumy</h1>
      <ul>
        <li className="one">Home |  </li>
        <li className="one">Products | </li>
        <li className="one">About |</li>
        <li className="one">Contact | </li>
      </ul>
    </nav>
  )
}

export default Navbar